import React, { Component } from 'react';

import Col from './Col';
import Row from './Row';
import Label from './Label';
import Header from './Header';

class ThreeYearsTableLayout extends Component {
	render() {
		return (
			<div className="three-years-table-layout">{this.props.children}</div>
		);
	}
}

Object.assign(ThreeYearsTableLayout, {
	Col,
	Row,
	Label,
	Header
});

export default ThreeYearsTableLayout;
